import AnnouncerAgent from './AnnouncerAgent'

export default AnnouncerAgent